import { render, staticRenderFns } from "./StepVcte.vue?vue&type=template&id=2cbcf28f&"
import script from "./StepVcte.vue?vue&type=script&lang=js&"
export * from "./StepVcte.vue?vue&type=script&lang=js&"
import style0 from "./StepVcte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCardText,VCol,VRow,VSheet})
